import React from 'react';
import { Table } from 'semantic-ui-react';
import RequestTransferButton from './RequestTransferButton';

const RequestTransferCell = ({ allowTransfer, onClick, request }) => (
  <Table.Cell
    className="aridhia-request-transfer-cell"
    verticalAlign={allowTransfer ? 'middle' : undefined}
  >
    {!allowTransfer && <>{request.transferredOn}</>}
    {allowTransfer && (<RequestTransferButton request={request} onClick={onClick} className="aridhia-cell-button" />)}
  </Table.Cell>
);

export default RequestTransferCell;
